import axiosService from './axios.service';
import ResponseService from './response.service';

const update = async (_formData) => {
  try {
    let axiosData = {
      method: 'put',
      url: 'account_settings',
      isAuthorized: true,
      isMultipart: true, // true or false
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const updateUserLocalLang = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'account_settings/update_user_lang',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const details = async () => {
  try {
    let axiosData = {
      method: 'get',
      url: 'account_settings',
      isAuthorized: true,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const changePassword = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'account_settings/change_password',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const generateTwoFactorSecret = async (_formData = {}) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'account_settings/two_factor/generate',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const update2FAStatus = async () => {
  try {
    let axiosData = {
      method: 'put',
      url: 'account_settings/two_factor/change_status',
      isAuthorized: true,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const addUserWallets = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'account_settings/user_wallets',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};
const fetchCountries = async () => {
  try {
    let axiosData = {
      method: 'get',
      url: 'countries',
      isAuthorized: true,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const AccountSettingsService = {
  update,
  details,
  changePassword,
  generateTwoFactorSecret,
  addUserWallets,
  update2FAStatus,
  updateUserLocalLang,
  fetchCountries,
};

export default AccountSettingsService;
